__turbopack_context__.v({
  "additional-details": "cTLcdW_additional-details",
  "additional-profile-details-section": "cTLcdW_additional-profile-details-section",
  "additional-profile-details-section__container": "cTLcdW_additional-profile-details-section__container",
  "additional-profile-details-section__container-item": "cTLcdW_additional-profile-details-section__container-item",
  "additional-profile-details-section__heading": "cTLcdW_additional-profile-details-section__heading",
  "committee-details": "cTLcdW_committee-details",
  "committee-summary": "cTLcdW_committee-summary",
  "data-list": "cTLcdW_data-list",
  "data-list__label": "cTLcdW_data-list__label",
  "data-list__value": "cTLcdW_data-list__value",
  "pagination": "cTLcdW_pagination",
});
